import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import Select from 'react-select';
import { useFormikContext } from 'formik';
import { Card, Form } from 'components';
import useAvailableRegions from 'hooks/useAvailableRegions';

const NewRetailersWidgetFormFields = () => {
  const { t } = useTranslation('pages', { keyPrefix: 'widgets' });
  const { values, setFieldValue } = useFormikContext();

  const regions = useAvailableRegions();

  const regionOptions = useMemo(
    () =>
      regions
        .map(({ name, uid }) => ({ label: name, value: uid }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [regions],
  );

  useEffect(() => {
    if (!values.region && regionOptions.length > 0) {
      setFieldValue('region', regionOptions[0].value);
    }
  }, [regionOptions, values.region, setFieldValue]);

  const regionValue = regionOptions.find((opt) => opt.value === values.region) || null;

  return (
    <Col md={12}>
      <Form.GroupHorizontal label={t('selectRegion')} required>
        <Select
          options={regionOptions}
          value={regionValue}
          onChange={(option) => setFieldValue('region', option.value)}
          placeholder={t('selectRegionPlaceholder')}
        />
      </Form.GroupHorizontal>
    </Col>
  );
};

const NewRetailersWidgetConfiguration = () => {
  const { t } = useTranslation('pages', { keyPrefix: 'widgets' });

  return (
    <Card title={t('configuration')} subtitle={t('configurationSubtitle')} className="w-100">
      <Row>
        <NewRetailersWidgetFormFields />
      </Row>
    </Card>
  );
};

export default {
  titleKey: 'types.newRetailers',
  descriptionKey: 'types.newRetailersDescription',
  defaultValues: { region: '' },
  buildPayload: (values) => ({
    region_uids: [values.region],
  }),
  isValid: (values) => !!values.region,
  parseApiData: (widget) => ({
    region: widget.regions?.[0]?.uid || '',
  }),
  ConfigComponent: NewRetailersWidgetConfiguration,
};
